export default "__VITE_ASSET__CS_5nFO9__"